const stepsVisited = {
  yourInfoPage: false,
  vehiclesPage: false,
  driverPage: false,
  driverHistoryPage: false,
  moreInfoPage: false,
  quotePage: false,
  policyInformation_Vehicle: false,
  policyInformation_Driver: false,
  policyInformation_ContactDetails: false,
  policyInformation_MoreDetails: false,
  policyInformation_Summary: false,
  paymentDetails_PlansPage: false,
  paymentDetails_PaymentPage: false,
  paymentConfirmation_ConfirmationPage: false,
};

export default {
  setPageVisited: (page) => {
    stepsVisited[page] = true;

    // 🔥 If confirmation page is true → mark all as true
    if (page === "paymentConfirmation_ConfirmationPage" && stepsVisited[page]) {
      Object.keys(stepsVisited).forEach((key) => {
        stepsVisited[key] = true;
      });
    }
  },

  getPagesVisited: () => stepsVisited,
};
